import _ from "lodash";

import RiskProfileSelectionStep
  from "./components/StepContent/components/step/RiskProfile/components/RiskProfileSelectionStep";
import {CONGRATS_STEP_ID, CountryISOMapping, PHONE_FIELD_UID} from "./constants";

export const finalStep = {
  "uid": "final-step",
  "name": "Risikoprofil von {customer_name}: {risk_category}",
  "info": "Für diesen Kunden/ diese Kundin wird eine {risk_category} Anlagestrategie empfohlen.",
  "category": "Risikoprofil",
  "behaviour": ["final"],
  "question": [
    {
      "question_text": "Risikoprofil",
      "uid": "final_question_uid",
      "info": "Das Risikoprofil der Kunden wird anhand verschiedener Faktoren berechnet und spiegelt das Risiko wider, welches der/die Kunde/in nach dieser Berechnung grundsätzlich tragen kann. Sollte sich der/die Kunde/in mit dem errechneten Risikoprofil nicht identifizieren können, haben Sie die Möglichkeit, das Risikoprofil mittels Schieberegler anzupassen. Auf Grund regulatorischer Vorgaben ist jedoch nur eine Anpassung nach unten möglich.",
      "type": "normal",
      "behaviour": ["slider"]
    }
  ]
}

export const congratsStep = {
  "uid": CONGRATS_STEP_ID,
  "name": "Risikoprofilierung",
  "help": "Das heißt, für diesen Kunden wird eine moderate Anlagestrategie empfohlen werden.",
  "behaviour": ["congrats"],
}

export const riskProfileSelectionStep = {
  "uid": "risk-profile-selection-step",
  "name": "Bitte wählen Sie das Risikoprofil",
  "behaviour": ["dynamic"],
  "category": "Auswahl",
  "step_content": RiskProfileSelectionStep,
  "no_user_input": true,  // disable unsaved changes check as not relevant here
  "not_skippable": true,
  "question": [
    {
      "uid": "risk-profile-radio-uid",
      "type": "normal",
      "behaviour": ["radio"],
      "optional": false,
      "options": [
        {id: 1, value: 'new', label: 'Neues Risikoprofil anlegen'},
        {id: 2, value: 'select', label: 'Bereits durchgeführte Risikoprofilierung auswählen'},
      ]
    },
    {
      "uid": "risk-profile-select-uid",
      "question_text": "Risikoprofilierung",
      "type": "normal",
      "behaviour": ["select"],
      "optional": true,
    }
  ]
}

const getContact = (q, customer, findFunc, usePreferred=false) => {
  try {
    const contact = customer && (customer.contacts || []).find(contact => {
      let isValid = findFunc(contact)
      if (isValid && usePreferred) {
        isValid = contact.preferred
      }

      return isValid
    });
    q.dante_obj = contact;
    return contact && contact.value;
  } catch (e) {
    console.error(e);
  }
};

const getCustomerMobilePhone = (q, customer) => {
  // First check contacts by preferred flag
  return getContact(q, customer,contact => 'Mobiltelefon' === contact.type, true) || // mobile is preferable
    getContact(q, customer,contact => 'Mobiltelefon' === contact.type)
};

const getCustomerPhone = (q, customer) => {
  // First check contacts by preferred flag
  return getContact(q, customer,contact => 'Telefon' === contact.type, true) ||
    getContact(q, customer,contact => 'Telefon' === contact.type)
};

const setContactsAnswer = (answers, q, dante_obj, value) => {
  const contacts = _.get(answers, 'contacts', []);
  q.listErrorPath = `contacts.${contacts.length}.value`;
  if(!dante_obj.syncType) dante_obj.syncType = 'privat';
  return _.set(answers, 'contacts', [...contacts, {...dante_obj, value: value}]);
};

const getCustomerEmail = (q, customer) => {
  return getContact(q, customer, contact => 'E-Mail' === contact.type, true) ||
    getContact(q, customer, contact => 'E-Mail' === contact.type) ||
    customer.emailAppCustomer
};

const findRelationshipField = (relationshipIndex, fieldName) => {
  return (question, customer) => {
    question.customer_id = _.get(customer, `relationships.${relationshipIndex}.id`)
    return _.get(customer, `relationships.${relationshipIndex}.${fieldName}`)
  }
};

export const getRelationshipFieldConfiguration = (relationshipIndex, fieldName) => ({
  "dante_field_finder": findRelationshipField(relationshipIndex, fieldName),
  "dante_field_setter": () => undefined,
  "dante_error_field": fieldName,
  "dante_error_finder": (errors, question) => {
    if (!question.customer_id) {
      return undefined
    }

    const dante_error_field = `relationships.${question.customer_id}.errors`;
    let err = _.get(errors, dante_error_field);

    if (err) {
      return _.get(err, fieldName)
    }
  }
});

const salutationConfigs = {"dante_field": "salutation"}
export const personalInformationConfigs = {
  firstName: {"dante_field": "personalInformation.firstName"},
  lastName: {"dante_field": "personalInformation.lastName"},
  birthName: {"dante_field": "personalInformation.birthName"},
  title: {
    "dante_field": "personalInformation.title",
    "config": {"Dr.": "1", "Dr. Dr.": "2", "Prof. Dr.": "3", "Prof. Dr. Dr.": "4", "Prof.": "5", "Dipl. Ing.": "6"}
  }
};
const addressConfigs = {
  street: {"dante_field": "addresses.0.street"},
  zip: {"dante_field": "addresses.0.zip"},
  city: {"dante_field": "addresses.0.city"},
  country: {
    "dante_field": "addresses.0.country",
    "config": CountryISOMapping
  }
};
const legitimationPePConfigs = {
  "dante_field_finder": (q, customer) => {
    return _.get(customer, 'legitimation.0.peP')
  }
};
const contactsConfigs = {
  mobile:  {
    "dante_field_finder": getCustomerMobilePhone,
    "dante_field_setter": (answers, q, value) => {
      // default obj in case we create new
      const dante_obj = q.dante_obj || {type: 'Mobiltelefon'};
      return setContactsAnswer(answers, q, dante_obj, value);
    }
  },
  phone:  {
    "dante_field_finder": getCustomerPhone,
    "dante_field_setter": (answers, q, value) => {
      // default obj in case we create new
      const dante_obj = q.dante_obj || {type: 'Telefon'};
      return setContactsAnswer(answers, q, dante_obj, value);
    }
  },
  email: {
    "dante_field_finder": getCustomerEmail,
    "dante_field_setter": (answers, q, value) => {
      const dante_obj = q.dante_obj || {type: 'E-Mail'};
      return setContactsAnswer(answers, q, dante_obj, value);
    },
  }
};

export const birthConfigs = {
  birth_date: {
    "dante_field": "personalInformation.dateOfBirth"
  },
  birth_place: {
    "dante_field": "personalInformation.placeOfBirth"
  },
};

export const CustomerDataMapping = {
  "A2": salutationConfigs,
  "A201": salutationConfigs,
  "A202": salutationConfigs,
  "A4": personalInformationConfigs.title,
  "A401": personalInformationConfigs.title,
  "A402": personalInformationConfigs.title,
  "A5": personalInformationConfigs.firstName,
  "A501": personalInformationConfigs.firstName,
  "A502": personalInformationConfigs.firstName,
  "A6": personalInformationConfigs.lastName,
  "A601": personalInformationConfigs.lastName,
  "A602": personalInformationConfigs.lastName,
  "A7": addressConfigs.street,
  "A701": addressConfigs.street,
  "A702": addressConfigs.street,
  "A8": addressConfigs.zip,
  "A801": addressConfigs.zip,
  "A802": addressConfigs.zip,
  "A9": addressConfigs.city,
  "A901": addressConfigs.city,
  "A902": addressConfigs.city,
  "A10": addressConfigs.country,
  "A101": addressConfigs.country,
  "A102": addressConfigs.country,
  "A12": legitimationPePConfigs,
  "A1201": legitimationPePConfigs,
  "A1202": legitimationPePConfigs,
  "A14": personalInformationConfigs.birthName,
  "A1401": personalInformationConfigs.birthName,
  "A1402": personalInformationConfigs.birthName,
  "B1": contactsConfigs.mobile,
  "B101": contactsConfigs.mobile,
  "B102": contactsConfigs.mobile,
  "B2": contactsConfigs.email,
  "B201": contactsConfigs.email,
  "B202": contactsConfigs.email,
  [PHONE_FIELD_UID]: contactsConfigs.phone,
  [`${PHONE_FIELD_UID}01`]: contactsConfigs.phone,
  [`${PHONE_FIELD_UID}02`]: contactsConfigs.phone,
  "C1": birthConfigs.birth_date,
  "C101": birthConfigs.birth_date,
  "C102": birthConfigs.birth_date,
  "C2": birthConfigs.birth_place,
  "C201": birthConfigs.birth_place,
  "C202": birthConfigs.birth_place,
  "A50": {"dante_field": "personalInformation.lastName"},
  "A51": {
    ...getRelationshipFieldConfiguration(0, 'personalInformation.firstName')
  },
  "A52": {
    ...getRelationshipFieldConfiguration(0, 'personalInformation.lastName')
  },
  "A53": {
    ...getRelationshipFieldConfiguration(1, 'personalInformation.firstName')
  },
  "A54": {
    ...getRelationshipFieldConfiguration(1, 'personalInformation.lastName')
  },
  "J1": {
    "dante_field": "personalInformation.occupationalGroup",
    "config": {
      "1": "12", "2": "19", "3": "17", "4": "7", "5": "8", "6": "6",
      "7": "11", "8": "18", "9": "15", "10": "5", "11": "1", "12": "16", "13": "2",
      "14": "3", "15": "10", "16": "4", "17": "13", "18": "14", "19": "21", "20": "22",
      "21": "9", "22": "20"
    }
  },
  "J2": {
    "dante_field_finder": (q, customer) => {
      const branch = _.get(customer, 'business');
      const option = branch && (q.config.choices || []).find(i => i.text === branch);
      return _.get(option, 'uid');
    },
    "dante_field_setter": (answers, q, value) => {
      const branch = (q.config.choices || []).find(i => i.uid === value);
      return _.set(answers, 'business', _.get(branch, 'text', ''));
    }
  },
  "J3": {
    "dante_field": "personalInformation.highestLevelOfEducation",
    "config": {
      "1": "1", "2": "2", "3": "4", "4": "7", "5": "3", "8": "5", "9": "6"
    }
  }
};